import {throttle} from 'lodash';
import onReady from 'document-ready';

onReady(() => {
    let busy = false;

    const uploadData = throttle(
        () => {
            if (busy) return uploadData();

            let reports = app.store.getState().collect;
            if (reports.length) {
                busy = true;

                app.api.collect
                    .report(reports)
                    .catch(err => {
                        console.warn(err);
                        // Sentry.captureException(err);
                    })
                    .then(() => {
                        busy = false;
                    });
            }
        },
        2000,
        {leading: false}
    );

    let unsubscribe = app.store.observe(state => state.collect, uploadData);
    app.onShutdown(unsubscribe);
});
